module.exports = __webpack_public_path__ + "static/img/BranchCompany2.c2d0381f.png";